export default __webpack_public_path__ + "static/media/Error_Red.6efe5ce1.svg";